'use strict';

export const CashReqController = "cashReqCtrl";

/** @ngInject */
export const cashReqController = function($scope) {

};
